










import { Component, Vue, Watch } from 'vue-property-decorator'
import { wxConfigReady } from '@ivy/fts/weixin'
import { isWeixin } from '@ivy/fts/utils'

@Component
export default class App extends Vue {
  noWxLoginList: any = ['/vipcontinue', '/vipexplanation', '/disclaimer', '/play']
  isShowHeader: boolean = false
  async mounted() {
    let path = '/' + window.location.pathname.split('/').slice(2).join('/') // 去掉/wechat2
    if (this.$store.fromQr || this.noWxLoginList.includes(path.toLowerCase())) {
    } else {
      await wxConfigReady()
      await this.$store.login(this)
      this.$store.setupShare()
    }
    this.isShowHeader = this.$route.meta && this.$route.meta.isShowHeader
  }
  @Watch('$route')
  onRouteChanged(to) {
    this.isShowHeader = to.meta && to.meta.isShowHeader
    isWeixin() && this.$store.setupShare()
  }
}
console.log(`%c`, `padding: 20px 134px 0 0;line-height: 134px;background-size: cover;background-repeat: no-repeat;background-position: center;background-image: url('http://service.ivydad.com/tools/imagePage7e2d04ad-b315-2e99-ad28-9b8798403345.png');`)
